import ProductOptionsActionTypes from '../actionTypes/ProductOptionsActionTypes';

export const productOptionsOnClickAction = (payload) => ({
    type: ProductOptionsActionTypes.PRODUCTOPTIONS_ON_CLICK,
    payload,
    sourceMiniPDP: false,
});

export default {
    productOptionsOnClickAction,
};
